import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])
const date = filterOptions(['EQ', 'BT', 'LE'])

export const pageSearch = {
  'CUSTOMER': {
    title: '客户编码',
    type: 'dialog',
    equation: city,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    },
    unSearchRole: 'WLY001'
  },
  'POSTING_DATE': {
    title: '查询日期',
    type: 'date',
    equation: date
  }
}

export default {
  'billto_bp': {
    title: '客户编码',
    width: 200
  },
  'billto_name': {
    title: '客户名称',
    width: 250
  },
  'posting_date': {
    title: '上账日期',
    width: 200
  },
  'zy': {
    title: '摘要',
    width: 200
  },
  'forward_amount': {
    title: '金额',
    xlsxFmt: {
      t: 'n'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/dealer-manage/config/marketSupport.js